// history.pushState = function pushState() {
//   let ret = oldPushState.apply(this, arguments);
//   console.log('push', arguments)
//   if (arguments[1] !== 'anchor-product' && arguments[0]?.hasOwnProperty('refinementList')) {
//   }
//   return ret;
// };

// Helper function to check if a URL is a video link
window.isVideoLink = function(url) {
  if (!url) return false
  const videoRegex = /\.(mp4|webm|ogg|avi|mov|wmv|flv|mkv)/i
  return videoRegex.test(url)
}

// Bundle helper functions
window.BundleHelper = {
  // Add bundle items to cart (same logic as theme.js addBundleItems)
  async addBundleItems(variantIds) {
    return new Promise((resolve, reject) => {
      const queue = [...variantIds];
      
      const moveAlong = () => {
        if (queue.length) {
          const variantId = queue.shift();
          const data = 'id=' + variantId + '&quantity=1';
          
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: data
          })
          .then(res => res.json())
          .then(() => {
            moveAlong();
          })
          .catch(err => {
            console.error('Error adding item to cart:', err);
            moveAlong();
          });
        } else {
          resolve();
        }
      };
      
      moveAlong();
    });
  },

  // Handle bundle quick add click with variant IDs directly
  async handleBundleQuickAddWithIds(variantIds, buttonElement) {
    if (!variantIds || variantIds.length === 0) {
      console.error('No variant IDs provided for bundle');
      return;
    }

    if (buttonElement) {
      buttonElement.classList.add('loading');
      buttonElement.textContent = 'ADDING...';
    }

    try {
      // Add all bundle items to cart
      await this.addBundleItems(variantIds);
      
      // Update cart UI
      if (typeof UTI !== 'undefined' && UTI.ajaxcart) {
        UTI.ajaxcart.updateCart();
        $('html').addClass('mini-cart');
      }

      if (buttonElement) {
        buttonElement.classList.remove('loading');
        buttonElement.textContent = 'ADDED!';
        setTimeout(() => {
          buttonElement.textContent = 'ADD SET TO CART';
        }, 2000);
      }
    } catch (error) {
      console.error('Error handling bundle quick add:', error);
      if (buttonElement) {
        buttonElement.classList.remove('loading');
        buttonElement.textContent = 'ADD SET TO CART';
      }
    }
  }
};

if (!customElements.get('mobile-bag')) {
  customElements.define('mobile-bag', class MobileBag extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', async (event) => {
        event.preventDefault()
        event.stopImmediatePropagation()
        event.stopPropagation()

        // Check if this is a bundle product (set dynamically by renderProductVariants)
        const isBundle = this.getAttribute('data-is-bundle') === 'true'
        const bundleVariantIdsStr = this.getAttribute('data-bundle-variant-ids')

        if (isBundle && bundleVariantIdsStr) {
          // Handle bundle product - show popup with "ADD SET TO CART" button
          try {
            const bundleVariantIds = JSON.parse(bundleVariantIdsStr)
            window.mobileTrackingHit = JSON.parse((this.getAttribute('data-hit')))
            
            // Store bundle data for the CTA button click handler
            window.mobileBundleVariantIds = bundleVariantIds
            window.isMobileBundleAdd = true
            
            // Update popup for bundle
            document.querySelector('.mobile-quick-add').classList.remove('no-select')
            document.querySelector('.mobile-quick-add .q-value').style.display = 'none'
            document.querySelector('mobile-quick-add header div').style.display = 'none'
            document.querySelector('mobile-quick-add .q-text').textContent = 'ADD SET TO CART'
            document.querySelector('mobile-quick-add .q-text').classList.remove('disabled')
            document.querySelector('mobile-quick-add .q-text').classList.add('bundle-cta')
            
            // Show the popup
            document.querySelector('.ais-mobile-quick-add').classList.add('visible')
          } catch (e) {
            console.error('Error parsing bundle variant IDs:', e)
          }
          return
        }

        // Regular product - show size selector
        window.isMobileBundleAdd = false
        window.mobileBundleVariantIds = null
        
        const variantsStr = this.getAttribute('data-variants')
        if (!variantsStr) {
          console.log('Variants not loaded yet')
          return
        }
        const variants = JSON.parse(variantsStr).sort((a, b) => Number(a.text) - Number(b.text))
        window.mobileTrackingHit = JSON.parse((this.getAttribute('data-hit')))
        document.querySelector('.mobile-quick-add').classList.remove('no-select')
        document.querySelector('mobile-quick-add .q-text').textContent = 'ADD TO CART'
        document.querySelector('mobile-quick-add .q-text').classList.remove('bundle-cta')
        document.querySelector('.mobile-quick-add .q-value').innerHTML =
          variants.map(item => `<div class="q-item size-var ${item.text.toLowerCase()} ${item.available ? '' : 'oss'} ${variants.length === 1 ? 'active' : ''}" data-id="${item.id}">${item.text.toUpperCase()}</div>`).join('')

        if (variants.length === 1) {
          document.querySelector('.mobile-quick-add .q-value').style.display = 'none'
          window.mobileQuickAddTargetVariant = Number(variants[0].id)
          document.querySelector('mobile-quick-add .q-text').classList.remove('disabled')
          document.querySelector('mobile-quick-add header div').style.display = 'none'
        } else {
          document.querySelector('.mobile-quick-add .q-value').style.display = 'flex'
          document.querySelector('mobile-quick-add header div').style.display = 'block'
        }
        setTimeout(() => document.querySelectorAll('mobile-quick-add .q-item').forEach(item => item.addEventListener('click', (event) => {
          document.querySelectorAll('mobile-quick-add .q-item').forEach(sub => sub.classList.remove('active'))

          event.target.classList.add('active')
          window.mobileQuickAddTargetVariant = Number(event.target.getAttribute('data-id'))
          document.querySelector('mobile-quick-add .q-text').classList.remove('disabled')
          document.querySelector('.mobile-quick-add').classList.remove('no-select')
        })), 50)
        document.querySelector('.ais-mobile-quick-add').classList.add('visible')
      })
    }
  })
}

if (!customElements.get('pdp-redirect')) {
  customElements.define('pdp-redirect', class PDPRedirect extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', () => {
        const url = new URL(location);
        url.searchParams.set("page", this.getAttribute('data-page'));
        history.pushState({}, "anchor-product", url);
        location.href = this.getAttribute('data-url')
        sessionStorage.setItem('plp-object-id', this.getAttribute('data-object-id'))
      })
    }
  })
}

window.renderVariantIndex = 0

function triggerLoadMore() {
  if (document.querySelector('.ais-InfiniteHits-loadMore')
    ?.classList.contains('ais-InfiniteHits-loadMore--disabled')) {
    return
  }

  if (document.querySelector('.ais-InfiniteHits-loadMore')) {
    window.renderVariantIndex = 0
    document.querySelector('.ais-page').classList.add('ais-loading')
    document.querySelector('.ais-InfiniteHits-loadMore')?.click()
  } else {
    setTimeout(() => {
      triggerLoadMore()
    }, 100)
  }
}

// let isFirstLoadMore = true
document.addEventListener('DOMContentLoaded', () => {
  // Bundle quick-add button click handler (desktop)
  document.body.addEventListener('click', async (event) => {
    if (event.target.classList.contains('bundle-quick-add-btn')) {
      event.preventDefault()
      event.stopPropagation()
      
      // Check if unavailable
      if (event.target.getAttribute('data-unavailable') === 'true') {
        return
      }

      const bundleVariantIdsStr = event.target.getAttribute('data-bundle-variant-ids')
      if (bundleVariantIdsStr) {
        try {
          const bundleVariantIds = JSON.parse(bundleVariantIdsStr)
          await window.BundleHelper.handleBundleQuickAddWithIds(bundleVariantIds, event.target)
        } catch (e) {
          console.error('Error parsing bundle variant IDs:', e)
        }
      }
    }
  })

  if (location.pathname.includes('collections') || location.pathname.includes('search')) {
    let watchFooter

    let footer = document.querySelector('#shopify-section-footer')

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!document.querySelectorAll('.ais-InfiniteHits-item').length) {
          return
        }
        if (entry.isIntersecting) {
          triggerLoadMore()
        }
      });
    }, {
      threshold: 0,
      // rootMargin: watchFooter
      //   ? '0px 0px 0px 0px'
      //   : `${footer.clientHeight * 2}px 0px 0px 0px`
    });

    observer.observe(footer)

    let loadPreScrollAnchor = null
    let needScrollForPrevious = false
    let hasSetUpLoadPrevious = false

    const listObs = new MutationObserver((mutations) => {
      // console.log(mutations)
      if (!hasSetUpLoadPrevious) {
        document.querySelector('.ais-InfiniteHits-loadPrevious')?.addEventListener('click', () => {
          loadPreScrollAnchor = document.querySelector('.ais-InfiniteHits-list li:nth-child(1)')
          needScrollForPrevious = true
        })
        hasSetUpLoadPrevious = true
      } else if (needScrollForPrevious && mutations.find(item => item.target.classList.contains('ais-InfiniteHits-list'))) {
        setTimeout(() => {
          loadPreScrollAnchor.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }, 200)
        needScrollForPrevious = false
      }
    })

    listObs.observe(document.querySelector('.ais-hits-container'), {
      childList: true,
      subtree: true
    })
  }


  function setAutoCompleteTop() {
    const panel = document.querySelector('.aa-Panel')
    if (panel && window.innerWidth > 680) {
      const rect = document.querySelector('#header .main-search .search-wrap .form').getBoundingClientRect()
      panel.style.top = `${rect.bottom + window.scrollY}px`
    }
  }

  window.addEventListener('scroll', () => {
    setAutoCompleteTop()
  })

  document.querySelector('#header').addEventListener('transitionend', () => {
    setAutoCompleteTop()
  })
  document.querySelector('.nav-search').addEventListener('click', (e) => {
    // if (window.innerHeight <= 680) {
    //   $('.aa-DetachedSearchButton').click()
    //   console.log('search click')
    // } else {
    const child = e.target.matches(".nav-search, .nav-search *");
    if (child) {

      $('body').addClass('se-st');
      setTimeout(function () {
        $('body').addClass('se');

        if (window.innerWidth <= 680) {
          document.querySelector('.aa-DetachedSearchButton').click()
          document.body.style.overflow = 'hidden'
          setTimeout(() => {
            document.querySelector('.aa-DetachedCancelButton').addEventListener('click', () => {
              document.body.style.overflow = ''
              document.querySelector('.main-search .close').click()
            })
          }, 50);
          setTimeout(() => {

            // document.getElementById('autocomplete-0-input').setAttribute('autofocus', 'autofocus');
            // console.log(document.getElementById('autocomplete-0-input'));

            // document.getElementById('autocomplete-0-input').click();

          }, 500);
        } else {
          $('#autocomplete-0-input').focus()
        }
      }, 50);
    }

    // }
  })

})

if (!customElements.get('swipe-handle')) {
  customElements.define('swipe-handle', class SwipeHandle extends HTMLElement {
    constructor(props) {
      super(props);

      this.addEventListener('click', event => {
        event.stopPropagation()
        event.stopImmediatePropagation()
        event.preventDefault()

        if (this.classList.contains('pre-btn')) {
          window[`fy_${this.getAttribute('data-object-id')}`].previous()
        } else {
          window[`fy_${this.getAttribute('data-object-id')}`].next()
        }
      })
    }

  })
}
window.mobileCheck = function () {
  let check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.top_desktop .close').addEventListener('click', () => {
    document.body.removeChild(
      document.querySelector('.aa-Panel:last-child')
    )
  })
  if (!mobileCheck()) {
    history.scrollRestoration = 'manual';
  }

  document.querySelector('.cart-btn button')?.addEventListener('click', () => {
    try {
      const localStorageKey_pdp = 'localStorageKey_pdp';
      algoliaShopify.saveForConversionTracking(JSON.parse(localStorage.getItem(localStorageKey_pdp)));
    } catch (e) {
      console.error(e)
    }
  })


})

if (!customElements.get('algolia-product')) {
  customElements.define('algolia-product', class AlgoliaProduct extends HTMLElement {
    constructor() {
      super();
      this.colorGroupData = null;
      this.isLoading = false;
    }

    connectedCallback() {
      // 读取 data-color-group 属性
      const targetElement = this.querySelector("#color-swatch");

      if (targetElement) {
        this.loadColorGroupProducts(targetElement);
      }
    }
    
    // Check if video should be shown based on data-video-tag attribute
    // data-video-tag is set to 'algolia-video-enabled' when this product should show video
    shouldShowVideo() {
      return this.getAttribute('data-video-tag') === 'algolia-video-enabled'
    }
    
    // Check if new product data has video in its images
    hasVideoInImages(productImages) {
      if (!productImages || !Array.isArray(productImages)) return false
      return productImages.some(item => 
        item.type === 'video' || window.isVideoLink(item.src)
      )
    }
    
    // Get the first video from product images
    getFirstVideo(productImages) {
      if (!productImages || !Array.isArray(productImages)) return null
      return productImages.find(item => 
        item.type === 'video' || window.isVideoLink(item.src)
      )
    }

    async loadColorGroupProducts(targetElement) {
      // 防止重复请求
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      try {
        fetch(`/products/${this.getAttribute('data-handle')}?section_id=plp-product-metafields`)
          .then(res => res.text())
          .then(res => {
            const html = new DOMParser().parseFromString(res, 'text/html')
            const script = html.querySelector('script[type="application/json"]')
            const data = JSON.parse(script.textContent)

            if (data.product_group) {
              const url = `/collections/available-products?filter.p.m.product.product_code_erp=${data.product_group}`;
              fetch(url)
                .then((response) => {
                  if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                  }
                  return response.text();
                })
                .then((html) => {
                  if (targetElement) {
                    const currentSwatchId = this.getAttribute("data-swatch-id")
                    const tempDiv = document.createElement('div')
                    tempDiv.innerHTML = html
                    const allDivs = Array.from(tempDiv.querySelectorAll('div'))

                    const sortedDivs = allDivs.sort((a, b) => {
                      const aMatches = a.getAttribute('data-swatch-id') === currentSwatchId
                      const bMatches = b.getAttribute('data-swatch-id') === currentSwatchId
                      if (aMatches && !bMatches) return -1
                      if (!aMatches && bMatches) return 1
                      return 0
                    }).filter(item => item.style.display !== 'none')

                    targetElement.innerHTML = sortedDivs.map(div => div.outerHTML).join('')

                    targetElement.querySelectorAll('div').forEach(item => {
                      if (item.getAttribute('data-swatch-id') === currentSwatchId) {
                        item.classList.add('active')
                      }
                    })

                    if (sortedDivs.length > 2) {
                      const plusElement = document.createElement('div')
                      plusElement.innerHTML = '+' + (sortedDivs.length - 2)
                      plusElement.classList.add('plus')
                      targetElement.appendChild(plusElement)
                    }
                  } else {
                    console.error("Target element or content not found.");
                  }
                })
                .catch((error) => {
                  console.error("Error fetching or injecting content:", error);
                });
            }
          })
      } finally {
        this.isLoading = false;
      }
    }

    // 获取颜色组数据的公共方法
    getColorGroupData() {
      return this.colorGroupData;
    }

    // 刷新颜色组数据
    async refreshColorGroupData() {
      const colorGroup = this.getAttribute('data-color-group');
      if (colorGroup && colorGroup !== 'null' && colorGroup !== 'undefined') {
        this.colorGroupData = null;
        this.isLoading = false;
        await this.loadColorGroupProducts(colorGroup);
      }
    }
  })
}

if (!customElements.get('plp-color-swatch')) {
  customElements.define('plp-color-swatch', class PLPColorSwatch extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', (event) => {
        if (event.target.classList?.contains('plus')) {
          return
        }

        let handle = ''
        if (event.target.getAttribute('data-swatch-id')) {
          handle = event.target
        } else {
          handle = event.target.parentElement
        }

        event.stopPropagation()
        event.stopImmediatePropagation()
        event.preventDefault()
        this.querySelectorAll('[data-swatch-id]').forEach(item => {
          item.classList.remove('active')
        })

        handle.classList.add('active')

        handle.closest('pdp-redirect').setAttribute('data-url', handle.querySelector('a').getAttribute('href'))
        handle.closest('algolia-product').querySelector('.media-container').setAttribute('href', handle.querySelector('a').getAttribute('href'))
        handle.closest('algolia-product').querySelector('.main-carousel').setAttribute('data-url', handle.querySelector('a').getAttribute('href'))

        const script = handle.querySelector('script[type="application/json"]')
        const data = JSON.parse(script.textContent)

        const card = this.closest('algolia-product')

        // 构建 product-item-label HTML
        function buildProductLabels(tags, namedTags, price, compareAtPrice) {
          let productLabels = []
          let isSet = false

          // 检查是否是 SET 产品
          if (namedTags && namedTags['CODE']) {
            if (Array.isArray(namedTags['CODE'])) {
              isSet = !!namedTags['CODE'].find(item => item.includes("I'M A SET"))
            } else if (typeof namedTags['CODE'] === 'string') {
              isSet = namedTags['CODE'].includes("I'M A SET")
            }
          }

          // 处理 Badges
          if (tags && (tags.find(item => item.includes('Badges|')) || tags.find(item => item.includes('CODE:')))) {
            const badgesArray = tags
              .filter(item => item.includes('Badges|') || item.includes('CODE:'))
              .map(item => item.replace('Badges|', '').replace('CODE:', ''))

            let badgeName
            if (badgesArray.includes('100% FRENCH LINEN')) {
              badgeName = '100% FRENCH LINEN'
            } else if (badgesArray.includes('SELLING FAST')) {
              badgeName = 'SELLING FAST'
            } else if (badgesArray.includes('RECYCLED')) {
              badgeName = 'RECYCLED MATERIAL'
            } else {
              for (const tag of badgesArray) {
                if (tag) {
                  badgeName = tag
                  break
                }
              }
            }

            if (badgeName && window.theme?.materialBadge) {
              const badge = window.theme.materialBadge.find(item => item.name == badgeName)
              if (badge?.link) {
                productLabels.push(`<span><a href="${badge.link}">${badgeName.toLowerCase()}</a></span>`)
              } else {
                productLabels.push(`<span>${badgeName.toLowerCase()}</span>`)
              }
            }
          }

          // 处理 named_tags 中的 CODE 标签
          if (namedTags) {
            Object.keys(namedTags).forEach(item => {
              const value = namedTags[item]
              if (!item.includes('CODE')) return

              if (window.theme?.materialBadge?.find(item => item.name == value)) {
                const badge = window.theme.materialBadge.find(item => item.name == value)
                if (badge?.link) {
                  productLabels.push(`<span><a href="${badge.link}">${value.toLowerCase()}</a></span>`)
                }
              } else {
                let tag = ''
                if (Array.isArray(value)) {
                  tag = value[value.length - 1]
                } else {
                  tag = value
                }
                productLabels.push(`<span>${tag.toLowerCase()}</span>`)
              }
            })
          }

          // 处理 new 标签
          if (tags) {
            for (const key of tags) {
              if (key.includes('new')) {
                if (window.theme?.materialBadge?.find(item => item.name.toLowerCase() == 'new')) {
                  const badge = window.theme.materialBadge.find(item => item.name.toLowerCase() == 'new')
                  if (badge?.link) {
                    productLabels.push(`<span><a href="${badge.link}">New</a></span>`)
                  }
                } else {
                  productLabels.push('<span>New</span>')
                }
                break
              }
            }

            // 处理 coming-soon 标签
            if (tags.find(item => item.includes('coming-soon'))) {
              if (window.theme?.materialBadge?.find(item => item.name.toLowerCase() == 'coming soon')) {
                const badge = window.theme.materialBadge.find(item => item.name.toLowerCase() == 'coming soon')
                if (badge?.link) {
                  productLabels.push(`<span><a href="${badge.link}">Coming Soon</a></span>`)
                }
              } else {
                productLabels.push('<span>Coming Soon</span>')
              }
            }
          }

          // 处理 Sale 标签
          if (compareAtPrice && price && compareAtPrice > price) {
            if (window.theme?.materialBadge?.find(item => item.name.toLowerCase() == 'sale')) {
              const badge = window.theme.materialBadge.find(item => item.name.toLowerCase() == 'sale')
              if (badge?.link) {
                productLabels.push(`<span><a href="${badge.link}">Sale</a></span>`)
              }
            } else {
              productLabels.push('<span>Sale</span>')
            }
          }

          return productLabels.join('')
        }

        // 获取 algolia-product 的 data-show-swipe 和 data-video-tag 属性
        const showSwipe = card.getAttribute('data-show-swipe') === 'true'
        
        // Check if this product card should show video
        // data-video-tag is set to 'algolia-video-enabled' when video should be displayed
        const shouldShowVideo = card.getAttribute('data-video-tag') === 'algolia-video-enabled'
        
        // Check if new product has video in its images and if the new product has 'algolia-video-enabled' tag
        const newProductHasVideoTag = data.tags && data.tags.find(item => item === 'algolia-video-enabled')
        
        // 获取产品图片数据
        const allImages = data.productImages || []
        
        // 查找视频文件
        const firstVideo = allImages.find(item => 
          item.type === 'video' || window.isVideoLink(item.src)
        )
        
        // Determine if we should show video for this swatch
        // Video shows if: original card should show video AND new product has video tag AND has video file
        const videoTag = shouldShowVideo && newProductHasVideoTag && firstVideo
        
        // 排序：如果需要显示视频，把视频排到前面
        const sortedImages = [...allImages].sort((a, b) => {
          const aIsVideo = a.type === 'video' || window.isVideoLink(a.src)
          const bIsVideo = b.type === 'video' || window.isVideoLink(b.src)

          // 视频排在前面
          if (aIsVideo && !bIsVideo) return -1
          if (!aIsVideo && bIsVideo) return 1
          return 0 // 保持原有顺序
        })

        const hitImage = sortedImages.slice(0, 3) // 限制最多3张

        // 构建移动端图片 HTML，同步 renderProductImage 的逻辑
        let mobileImageHtml = ''

        // 如果有视频且应该显示视频，添加视频元素（参考 renderProductImage 方法）
        if (firstVideo && videoTag) {
          mobileImageHtml += `
              <div class="carousel-cell videoc"><video
                    src="${firstVideo.src}" autoplay muted loop preload="auto" playsinline
                    height=""
                    style=""
              ></video></div>
           `
        }

        // 添加非视频图片
        const nonVideoImages = hitImage.filter(item =>
          item.type !== 'video' && !window.isVideoLink(item.src)
        )
        
        if (nonVideoImages.length > 0) {
          nonVideoImages.forEach((item, i) => {
            mobileImageHtml += `
                  <img alt="image"
                        class="fade-in-from-left swap--visible secondary carousel-cell"
                        style="visibility: hidden;"
                        data-sizes="auto"
                        data-flickity-lazyload="${item.src}&width=500"
                        height=""
                        style=""
                  />
               `
          })
        }

        // 更新桌面端 hover 图片（使用第二张非视频图片）
        if (nonVideoImages.length > 1) {
          const secondImage = nonVideoImages[1]
          if (secondImage && card.querySelector('.desktop-hover-image')) {
            card.querySelector('.desktop-hover-image').src = secondImage.src
          }
        }

        // 更新现有轮播图片元素
        card.querySelectorAll('.carousel-cell').forEach((item, index) => {
          if (hitImage[index] && hitImage[index].src) {
            item.src = hitImage[index].src
          } else {
            item.style.display = 'none'
          }
        })

        // 更新移动端轮播图片
        const mobileSwipeContainer = card.querySelector('.mobile-swipe-images')
        if (mobileSwipeContainer) {
          // 销毁现有的 Flickity 实例
          const objectID = card.getAttribute('data-algolia-objectid')
          const existingFlkty = window[`fy_${objectID}`]
          if (existingFlkty) {
            existingFlkty.destroy()
          }

          // 更新 HTML 内容
          mobileSwipeContainer.innerHTML = mobileImageHtml

          // 重新初始化 Flickity
          setTimeout(() => {
            const flktyConfig = {
              cellAlign: 'left',
              prevNextButtons: false,
              wrapAround: true,
              lazyLoad: 1,
              pageDots: true,
              dragThreshold: 10,
              on: {
                ready() {
                  card.querySelectorAll('.placeholder')
                    .forEach(item => {
                      item.src = "{{ 'Loading_Image_Grey_nologo.jpg' | asset_url }}";
                      item.setAttribute('alt', 'Loading Image')
                    })
                }
              }
            };

            const flkty = new Flickity(mobileSwipeContainer, flktyConfig);

            // 如果包含视频，等待视频加载元数据
            if (mobileImageHtml.includes('<video')) {
              setTimeout(() => {
                flkty.reposition()
              }, 50)
            }

            window[`fy_${objectID}`] = flkty

            flkty.on('lazyLoad', (event, cellElement) => {
              cellElement.style.visibility = 'visible'
            })

            // 重新添加点击事件处理器
            flkty.on('staticClick', (clickEvent) => {
              clickEvent.preventDefault()
              clickEvent.stopPropagation()

              const targetHit = card
              const url = new URL(location);
              url.searchParams.set("page", mobileSwipeContainer.getAttribute('data-page'));
              url.searchParams.set("scrollTo", mobileSwipeContainer.getAttribute('data-url'));
              history.pushState({}, "anchor-product", url);
              location.href = mobileSwipeContainer.getAttribute('data-url')
            })

            card.querySelector('.inside .media-container').classList.remove('disabled')
          }, 100)

          // 如果图片数量少于等于1，隐藏滑动控制
          if (hitImage.length <= 1) {
            card.querySelectorAll('swipe-handle').forEach(item => {
              item.style.display = 'none'
            })
          }
        }

        // 处理 variant 数据并更新 quick-add HTML
        if (data.variants && data.variants.length > 0) {
          let firstAvailableVariant = data.variants.find(v => v.available)
          const quickAddContainer = card.querySelector('.quick-add .qvalue')
          if (quickAddContainer) {
            // 创建新的 variant HTML
            let variantHtml = ''

            data.variants.forEach(variant => {
              const size = variant.option2?.toLowerCase() || ''
              const isActive = firstAvailableVariant?.id === variant.id && data.variants.length === 1
              const isOOS = !variant.available

              variantHtml += `<div class="${isOOS ? 'oos' : ''} size-var ${size} ${isActive ? 'active' : ''}" data-p-id="${variant.id}">${size}</div>`
            })

            // 更新 quick-add 区域
            quickAddContainer.innerHTML = variantHtml

            // 不需要额外添加点击事件，因为 theme.js 已经通过事件委托处理了
            // 事件委托在 theme.js 第 2188 行：$('body').on('click','.qvalue [data-p-id]',function(){...})
          }
          // 更新价格显示 - 使用第一个可用的 variant
          const priceContainer = card.querySelector('.price')
          if (priceContainer && firstAvailableVariant) {
            let priceHtml = ''
            const price = firstAvailableVariant.price
            const comparePrice = firstAvailableVariant.compareAtPrice
            const rate = Number(window.Shopify.currency.rate) / 100

            // 如果有原价且不等于现价，显示对比价格
            if (comparePrice && comparePrice !== price) {
              priceHtml = `<span class="money compare nocur">$${(comparePrice * rate).toFixed(2)}</span><span class="money sale">$${(price * rate).toFixed(2)}</span>`
            } else {
              // 只显示单一价格
              priceHtml = `<span class="money">$${(price * rate).toFixed(2)}</span>`
            }

            priceContainer.innerHTML = priceHtml
          }

          // 更新 mobile-add-button 的 data-variants 属性
          const mobileAddBtn = card.querySelector('.mobile-add-button')
          if (mobileAddBtn) {
            const mobileVariants = data.variants.map(variant => ({
              id: variant.id,
              available: variant.available,
              text: variant.option2?.toLowerCase() || ''
            }))
            mobileAddBtn.setAttribute('data-variants', JSON.stringify(mobileVariants))
          }
        }

        // 更新 product-item-label
        const labelContainer = card.querySelector('.product-item-label')
        if (labelContainer && data.tags) {
          const firstAvailableVariant = data.variants?.find(v => v.available)
          const labelsHtml = buildProductLabels(
            data.tags,
            data.namedTags,
            firstAvailableVariant?.price,
            firstAvailableVariant?.compareAtPrice
          )
          labelContainer.innerHTML = labelsHtml
        }

        this.setAttribute('data-current-swatch-id', event.target.getAttribute('data-swatch-id'))
      })
    }
  })
}